import styled, { css } from 'styled-components';

export const ToggleSectionWrapper = styled.div`
    ${({ isFromBPT }) =>
        isFromBPT
            ? css`
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: baseline;
                  margin: 1.5rem 0;
              `
            : css`
                  position: absolute;
                  top: 574px;
                  text-align: center;
                  left: 43%;
              `}
`;
export const ToggleSectionOptions = styled.span`
    font-size: 14px;
    color: ${({ theme }) => theme.blue[950]};
`;
